<template>
    <ul :class="{ 'in_modal': inModal }" class="history-list">
        <li><hr /></li>
        <li v-for="(d,i) in list" :key="i">
            Решения отсутствуют {{dateParser(d)}} г.
        </li>
    </ul>
</template>

<script>
export default {
    props: {
        list: Array,
        inModal: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="sass" scoped>
@import 'styles/global-variables'

.history-list
    margin: 0
    padding: 0
    @include column(5px)
    li
        font-size: 13px
        line-height: 18px
        color: #444
        hr
            margin: 0
            border-top: 1px solid #111
    &.in_modal
        li
            font-size: 16px
</style>